import sendReportRequest from './sendReportRequest';

const fetchReportCustomersOverview = async ({ dateRange, from, to, unit, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/customers',
    dateRange,
    from,
    to,
    unit,
    reportingType,
  });

  return reponseData;
};

export default fetchReportCustomersOverview;
